import { render, staticRenderFns } from "./informational-table.vue?vue&type=template&id=73fec6dd"
import script from "./informational-table.vue?vue&type=script&lang=js"
export * from "./informational-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports